import { CSSProperties, ReactNode } from "react";
import { useDroppable } from "@dnd-kit/core";
import { twMerge } from "tailwind-merge";
import { usePalette } from "@/shared/theme";

export function Droppable({
  children,
  id,
  className,
}: {
  children: ReactNode;
  id: string;
  className?: string;
}) {
  const { setNodeRef, isOver } = useDroppable({ id });
  const palette = usePalette();

  return (
    <div
      style={
        {
          "--over-bg-color": palette.success[1],
        } as CSSProperties
      }
      className={twMerge("p-2", className, isOver && "bg-[--over-bg-color]")}
      ref={setNodeRef}
    >
      {children}
    </div>
  );
}
